export default __webpack_public_path__ + "static/media/sixScores.dbb7504d.mp4";